__webpack_require__.p = "/manuscript/page/";